import React from 'react';
import { cn } from '../../../utils/cn';
import { THREAD_STATUS } from '../constants';

const StatusBadge = ({ status, className }) => {
  const meta = THREAD_STATUS[status] ?? { label: status || '—', className: 'bg-gray-100 text-gray-600' };

  return <span className={cn('inline-flex shrink-0 rounded-full px-2 py-0.5 text-xs font-medium', meta.className, className)}>{meta.label}</span>;
};

export default StatusBadge;
